module.exports = __webpack_public_path__ + "static/media/Repair-white.4d19bad7.svg";